import { combineReducers } from 'redux'
import AutoPaymentsMainReducer from './autoPayments.main.reducer'
import AutoPaymentsDebtsReducer from './autoPayments.debts.reducer'

const AutoPaymentsReducer = combineReducers({
  main: AutoPaymentsMainReducer,
  debts: AutoPaymentsDebtsReducer,
})

export default AutoPaymentsReducer